import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "144",
  height: "58",
  viewBox: "0 0 144 58",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", { d: "M143.6.4H.4v46.95h143.2V.4Zm-3.2 3.2v40.549H3.6V3.6h136.8Z" }),
      _createElementVNode("path", { d: "M128.158.4H15.84v32.516h112.317V.4Zm-3.201 3.2v26.116H19.04V3.6h105.917Z" }),
      _createElementVNode("path", { d: "M73.6 2v29.316h-3.2V2zM128.2 45.75V57H125V45.75zM19.041 45.75V57h-3.2V45.75z" })
    ], -1)
  ])))
}
export default { render: render }